export class CNPJValidate {
  private static readonly cnpjSizeWithoutDV: number = 12;
  private static readonly regexCNPJWithoutDV: RegExp = /^([A-Z\d]){12}$/;
  private static readonly regexCNPJ: RegExp = /^([A-Z\d]){12}(\d){2}$/;
  private static readonly regexCharactersMask: RegExp = /[./-]/g;
  private static readonly regexCharactersNotAllowed: RegExp = /[^A-Z\d./-]/i;
  private static readonly baseValor: number = "0".charCodeAt(0);
  private static readonly dvWeights: number[] = [
    6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2,
  ];
  private static readonly cnpjZeroed: string = "00000000000000";

  static isValid(cnpj: string): boolean {
    if (!this.regexCharactersNotAllowed.test(cnpj)) {
      let cnpjWithoutMask = this.removeCNPJMask(cnpj);
      if (
        this.regexCNPJ.test(cnpjWithoutMask) &&
        cnpjWithoutMask !== CNPJValidate.cnpjZeroed
      ) {
        const dvInformed = cnpjWithoutMask.substring(this.cnpjSizeWithoutDV);
        const dvCalculate = this.calculateDV(
          cnpjWithoutMask.substring(0, this.cnpjSizeWithoutDV),
        );
        return dvInformed === dvCalculate;
      }
    }
    return false;
  }

  static calculateDV(cnpj: string): string {
    if (!this.regexCharactersNotAllowed.test(cnpj)) {
      let cnpjWithoutMask = this.removeCNPJMask(cnpj);
      if (
        this.regexCNPJWithoutDV.test(cnpjWithoutMask) &&
        cnpjWithoutMask !== this.cnpjZeroed.substring(0, this.cnpjSizeWithoutDV)
      ) {
        let sumDV1 = 0;
        let sumDv2 = 0;
        for (let i = 0; i < this.cnpjSizeWithoutDV; i++) {
          const asciiDigit = cnpjWithoutMask.charCodeAt(i) - this.baseValor;
          sumDV1 += asciiDigit * this.dvWeights[i + 1];
          sumDv2 += asciiDigit * this.dvWeights[i];
        }
        const remainderDV1 = sumDV1 % 11;
        const dv1 = remainderDV1 < 2 ? 0 : 11 - remainderDV1;
        sumDv2 += dv1 * this.dvWeights[this.cnpjSizeWithoutDV];
        const remainderDV2 = sumDv2 % 11;
        const dv2 = remainderDV2 < 2 ? 0 : 11 - remainderDV2;
        return `${dv1}${dv2}`;
      }
    }
    throw new Error(
      "Não é possível calcular o DV pois o CNPJ fornecido é inválido",
    );
  }

  private static removeCNPJMask(cnpj: string): string {
    return cnpj.replace(this.regexCharactersMask, "");
  }
}
